import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/ru';
import { formatNumber } from '@ubic/utils/formatters';

dayjs.locale('ru');
dayjs.extend(weekday);

export const formatDate = date => dayjs(date).format('DD.MM.YYYY');

export const formatDatePretty = date => dayjs(date).format('DD MMMM YYYY');

export const formatDateTime = date => dayjs(date).format('DD.MM.YYYY HH:mm');

export const formatWeekDay = date => dayjs(date).format('dd');

export const getRandomString = () => Math.random().toString(36).substr(2, 8);

export const humanReadableHours = hours => {
  if (Number.isInteger(hours)) {
    return `${formatNumber(hours)}ч`;
  }

  const fullHours = Math.floor(hours);
  const minutes = Math.round((hours - fullHours) * 60);

  return fullHours >= 1
    ? `${formatNumber(fullHours)}ч ${minutes}м`
    : `${minutes}м`;
};

export const hoursToIntervals = value => {
  const years = Math.floor(value / (24 * 365));
  const months = Math.floor((value - (years * 24 * 365)) / (24 * 30));
  const days = Math.floor(
    (value - (years * 24 * 365) - (months * 24 * 30)) / 24
  );
  const hours = Math.floor(
    value - (years * 24 * 365) - (months * 24 * 30) - (days * 24)
  );
  const minutes = Math.round(
    (value - (years * 24 * 365) - (months * 24 * 30) - (days * 24) - hours) * 60
  );

  return {
    years,
    months,
    days,
    hours,
    minutes,
  };
};

export const copyToClipboard = text => {
  const input = document.createElement('textarea');

  input.value = text;
  document.body.append(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
};

export const dateIsWeekend = date => {
  const weekDay = dayjs(date).weekday();
  // 5 is saturday; 6 is sunday
  return (
    weekDay === 5
    || weekDay === 6
  );
};

export const defaultWeekends = (year = dayjs().year()) => {
  let start = dayjs(`${year}-01-01`);
  const end = dayjs(`${year + 1}-01-01`);

  const weekends = [];
  do {
    if (dateIsWeekend(start)) {
      weekends.push(start.format('YYYY-MM-DD'));
    }
    start = start.add(1, 'day');
  } while (!start.isSame(end));

  return weekends;
};

export default {
  formatDate,
  formatDatePretty,
  formatWeekDay,
  dateIsWeekend,
  defaultWeekends,
  getRandomString,
  humanReadableHours,
  copyToClipboard,
};
